export default __webpack_public_path__ + "static/media/us-md.968ff713.svg";